

// 创造与生成工作流：producer
// 研究与分析工作流：researcher
// 优化与校验工作流：validator
// 认知构建工作流：mentor
// 交互与引导工作流：navigator

import { FlowStage, FlowTask } from "../left-data/novel.type";
import { sslog } from "@/lib/utils/sslog";

import { 
 system,
 guidance,
 tutor,
 researcher,
 producer,
 validator,
 novel
} from './basic-gemini-lang'
import { boolean } from "drizzle-orm/mysql-core";

/*
// 战略决策工作流组合函数
export function getStrategyWorkflow(href: string): FlowStage[] {
  return [
    // 从交互引导中获取需求澄清和目标设定
    {
      ...guidance[0],
      phaseKey: "strategy_guidance",
      phaseTitle: "战略问题定义与目标澄清",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    // 从研究分析中获取市场研究和数据分析
    {
      ...researcher[0],
      phaseKey: "strategy_research",
      phaseTitle: "战略环境与市场分析",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    // 从创造生成中获取方案生成
    {
      ...producer[0],
      phaseKey: "strategy_generation",
      phaseTitle: "战略方案生成与选项开发",
      phaseTasks: [producer[0].phaseTasks.find(task => task.shortName === "ideation")].filter(Boolean)
    },
    // 从优化校验中获取风险评估和方案优化
    {
      ...validator[0],
      phaseKey: "strategy_validation",
      phaseTitle: "战略方案评估与优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "feedback"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 推广运营工作流组合函数
export function getPromotionWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "promotion_guidance",
      phaseTitle: "推广目标与受众分析",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "promotion_research",
      phaseTitle: "市场研究与竞品分析",
      phaseTasks: researcher[0].phaseTasks
    },
    {
      ...producer[0],
      phaseKey: "promotion_generation",
      phaseTitle: "推广内容与策略生成",
      phaseTasks: producer[0].phaseTasks
    },
    {
      ...validator[0],
      phaseKey: "promotion_validation",
      phaseTitle: "推广方案测试与优化",
      phaseTasks: validator[0].phaseTasks
    }
  ].filter(Boolean) as FlowStage[];
}

// 产品设计工作流组合函数
export function getProductDesignWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "design_guidance",
      phaseTitle: "产品需求与用户洞察",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "design_research",
      phaseTitle: "用户研究与市场分析",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "design_generation",
      phaseTitle: "产品概念与原型设计",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "ideation" || task.shortName === "generation"
      )
    },
    {
      ...validator[0],
      phaseKey: "design_validation",
      phaseTitle: "设计测试与用户体验优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "feedback"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 软件开发工作流组合函数
export function getSoftwareDevWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "dev_guidance",
      phaseTitle: "需求分析与技术规划",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "dev_research",
      phaseTitle: "技术调研与方案设计",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "dev_generation",
      phaseTitle: "代码实现与功能开发",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )
    },
    {
      ...validator[0],
      phaseKey: "dev_validation",
      phaseTitle: "代码测试与质量保证",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "optimization"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 图文卡片工作流组合函数
export function getGraphicCardWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "card_guidance",
      phaseTitle: "卡片主题与风格定位",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation"
      )
    },
    {
      ...researcher[0],
      phaseKey: "card_research",
      phaseTitle: "内容收集与灵感获取",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection"
      )
    },
    {
      ...producer[0],
      phaseKey: "card_generation",
      phaseTitle: "图文内容生成与设计",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )
    },
    {
      ...validator[0],
      phaseKey: "card_validation",
      phaseTitle: "内容优化与格式调整",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "optimization"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 媒体文案工作流组合函数
export function getCopywritingWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "copy_guidance",
      phaseTitle: "文案目标与平台适配",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "copy_research",
      phaseTitle: "热点追踪与关键词研究",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "copy_generation",
      phaseTitle: "多平台文案生成与适配",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )
    },
    {
      ...validator[0],
      phaseKey: "copy_validation",
      phaseTitle: "文案优化与SEO检查",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "optimization"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 小说创作工作流组合函数
export function getNovelCreationWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "novel_guidance",
      phaseTitle: "小说概念与世界观构建",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "novel_research",
      phaseTitle: "背景研究与素材收集",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "novel_generation",
      phaseTitle: "故事发展与章节创作",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "ideation" || task.shortName === "generation"
      )
    },
    {
      ...validator[0],
      phaseKey: "novel_validation",
      phaseTitle: "情节连贯性与文风优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "feedback"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 音乐工坊工作流组合函数
export function getMusicWorkshopWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "music_guidance",
      phaseTitle: "音乐风格与情感定位",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "music_research",
      phaseTitle: "音乐理论与灵感获取",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "music_generation",
      phaseTitle: "旋律创作与歌词编写",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )
    },
    {
      ...validator[0],
      phaseKey: "music_validation",
      phaseTitle: "和声编排与混音优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "optimization"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

// 电影编剧工作流组合函数
export function getScreenplayWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "film_guidance",
      phaseTitle: "电影概念与核心冲突",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )
    },
    {
      ...researcher[0],
      phaseKey: "film_research",
      phaseTitle: "题材研究与背景设定",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )
    },
    {
      ...producer[0],
      phaseKey: "film_generation",
      phaseTitle: "剧本创作与分镜设计",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )
    },
    {
      ...validator[0],
      phaseKey: "film_validation",
      phaseTitle: "剧本评估与节奏优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "validation" || task.shortName === "feedback"
      )
    }
  ].filter(Boolean) as FlowStage[];
}

*/
  





// (请确保在此文件顶部已经导入了 guidance, researcher, producer, validator 等基础工作流数组)
// (以及 FlowStage, FlowTask 等类型定义)

/**
 * @description 组装战略决策工作流。
 * 流程：定义问题 -> 分析环境 -> 生成方案 -> 评估优化。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getStrategyWorkflow(href: string): FlowStage[] {
  return [
    // 1. 从交互引导中获取需求澄清和目标设定
    {
      ...guidance[0],
      phaseKey: "strategy_guidance",
      // shortKey: "s_guidance",
      phaseTitle: "战略问题定义与目标澄清",
      phaseDescription: "现在扮演一名资深的战略顾问，协助我高质量完成任务，任务目标是引导我深入探讨，清晰地定义我们面临的核心战略问题，并明确我们希望通过此战略达成的最终商业目标。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `strategy_guidance.${t.shortName}`}})
    },
    // 2. 从研究分析中获取市场研究和数据分析
    {
      ...researcher[0],
      phaseKey: "strategy_research",
      // shortKey: "s_research",
      phaseTitle: "战略环境与市场分析",
      phaseDescription: "现在扮演一名资深的市场分析师，协助我高质量完成任务，任务目标是针对我们已定义的目标，全面收集并分析宏观环境（PEST）、行业竞争格局（波特五力）以及我们自身的优劣势（SWOT）。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `strategy_research.${t.shortName}`}})
    },
    // 3. 从创造生成中获取方案生成
    {
      ...producer[0],
      phaseKey: "strategy_generation",
      // shortKey: "s_creation",
      phaseTitle: "战略方案生成与选项开发",
      phaseDescription: "现在扮演一名资深的战略规划师，协助我高质量完成任务，任务目标是基于前述的分析，为我生成至少三个不同方向的、可行的战略选项，并简要说明每个选项的核心逻辑。",
      phaseTasks: [producer[0].phaseTasks.find(task => task.shortName === "ideation")].filter(Boolean)//.map(t => { return {...t, value: `strategy_generation.${t.shortName}`}})
    },
    // 4. 从优化校验中获取风险评估和方案优化
    {
      ...validator[0],
      phaseKey: "strategy_validation",
      // shortKey: "s_validation",
      phaseTitle: "战略方案评估与优化",
      phaseDescription: "现在扮演一名资深的战略评审专家，协助我高质量完成任务，任务目标是对已生成的战略选项进行评估，分析各自的潜在风险、所需资源和预期回报，并提出优化建议。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "feedback" // "validation" -> "check"
      )//.map(t => { return {...t, value: `strategy_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装推广运营工作流。
 * 流程：明确目标 -> 市场研究 -> 内容策略 -> 测试优化。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getPromotionWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "promotion_guidance",
      // shortKey: "p_guidance",
      phaseTitle: "推广目标与受众分析",
      phaseDescription: "现在扮演一名资深的营销顾问，协助我高质量完成任务，任务目标是帮助我明确本次推广活动的核心目标（如品牌曝光、用户增长、销售转化），并精准定义我们的目标用户画像。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `promotion_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "promotion_research",
      // shortKey: "p_research",
      phaseTitle: "市场研究与竞品分析",
      phaseDescription: "现在扮演一名资深的市场研究员，协助我高质量完成任务，任务目标是调研当前市场的热点趋势、分析主要竞争对手的营销活动，并总结可供我们借鉴的成功策略或需要规避的陷阱。",
      phaseTasks: researcher[0].phaseTasks//.map(t => { return {...t, value: `promotion_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "promotion_generation",
      // shortKey: "p_creation",
      phaseTitle: "推广内容与策略生成",
      phaseDescription: "现在扮演一名资深的创意总监，协助我高质量完成任务，任务目标是基于目标和研究，为我策划完整的推广方案，包括核心创意、传播口号、内容形式、渠道选择和预算分配。",
      phaseTasks: producer[0].phaseTasks//.map(t => { return {...t, value: `promotion_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "promotion_validation",
      // shortKey: "p_validation",
      phaseTitle: "推广方案测试与优化",
      phaseDescription: "现在扮演一名资深的营销分析师，协助我高质量完成任务，任务目标是预估方案的关键绩效指标（KPIs），设计A/B测试方案，并对推广文案和素材提出优化建议，以最大化转化率。",
      phaseTasks: validator[0].phaseTasks//.map(t => { return {...t, value: `promotion_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装产品设计工作流。
 * 流程：用户洞察 -> 市场研究 -> 原型设计 -> 测试优化。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getProductDesignWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "design_guidance",
      // shortKey: "pd_guidance",
      phaseTitle: "产品需求与用户洞察",
      phaseDescription: "现在扮演一名资深的用户体验研究员，协助我高质量完成任务，任务目标是通过提问引导我深入挖掘目标用户的真实痛点、使用场景和潜在需求，共同定义产品的核心价值主张。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `design_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "design_research",
      // shortKey: "pd_research",
      phaseTitle: "用户研究与市场分析",
      phaseDescription: "现在扮演一名资深的产品分析师，协助我高质量完成任务，任务目标是研究市场上的竞品功能和设计，构建用户画像和用户旅程地图，为产品设计提供数据和事实支持。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `design_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "design_generation",
      // shortKey: "pd_creation",
      phaseTitle: "产品概念与原型设计",
      phaseDescription: "现在扮演一名资深的产品设计师，协助我高质量完成任务，任务目标是根据需求和研究，为我设计产品的核心功能、信息架构和用户流程，并生成低保真原型或线框图。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "ideation" || task.shortName === "generation"
      )//.map(t => { return {...t, value: `design_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "design_validation",
      // shortKey: "pd_validation",
      phaseTitle: "设计测试与用户体验优化",
      phaseDescription: "现在扮演一名资深的可用性测试专家，协助我高质量完成任务，任务目标是依据设计原则和用户反馈，评估当前产品设计的优缺点，并提出具体的、可执行的体验优化方案。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "feedback" // "validation" -> "check"
      )//.map(t => { return {...t, value: `design_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装软件开发工作流。
 * 流程：需求规划 -> 技术调研 -> 代码实现 -> 测试保证。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getSoftwareDevWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "dev_guidance",
      // shortKey: "sd_guidance",
      phaseTitle: "需求分析与技术规划",
      phaseDescription: "现在扮演一名资深的系统分析师，协助我高质量完成任务，任务目标是帮助我将模糊的产品需求转化为清晰、无歧义、可开发的功能规格说明书（PRD），并确定技术上的关键约束条件。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `dev_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "dev_research",
      // shortKey: "sd_research",
      phaseTitle: "技术调研与方案设计",
      phaseDescription: "现在扮演一名资深的软件架构师，协助我高质量完成任务，任务目标是根据功能规格，调研并推荐合适的技术栈、框架和第三方服务，并设计出系统的整体架构和数据库模型。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `dev_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "dev_generation",
      // shortKey: "sd_creation",
      phaseTitle: "代码实现与功能开发",
      phaseDescription: "现在扮演一名资深的高级程序员，协助我高质量完成任务，任务目标是根据设计文档，编写出高质量、可读性强、易于维护的核心功能代码，并提供必要的代码注释和单元测试。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )//.map(t => { return {...t, value: `dev_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "dev_validation",
      // shortKey: "sd_validation",
      phaseTitle: "代码测试与质量保证",
      phaseDescription: "现在扮演一名资深的质量保证（QA）工程师，协助我高质量完成任务，任务目标是对已实现的功能进行代码审查（Code Review），设计测试用例，并找出潜在的Bug、性能瓶颈和安全漏洞。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "optimization" // "validation" -> "check"
      )//.map(t => { return {...t, value: `dev_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装社媒图文（原图文卡片）工作流。
 * 流程：定位主题 -> 收集灵感 -> 生成内容 -> 优化调整。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getGraphicCardWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "card_guidance",
      // shortKey: "gc_guidance",
      phaseTitle: "图文主题与风格定位",
      phaseDescription: "现在扮演一名资深的社交媒体内容策划，协助我高质量完成任务，任务目标是帮助我确定这系列图文的核心主题、目标受众和视觉风格（如简约、复古、科技感等）。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation"
      )//.map(t => { return {...t, value: `card_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "card_research",
      // shortKey: "gc_research",
      phaseTitle: "内容收集与灵感获取",
      phaseDescription: "现在扮演一名资深的内容研究员，协助我高质量完成任务，任务目标是为我搜集与主题相关的热门话题、金句、数据或趣闻，作为图文内容的灵感和素材来源。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection"
      )//.map(t => { return {...t, value: `card_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "card_generation",
      // shortKey: "gc_creation",
      phaseTitle: "图文内容生成与设计",
      phaseDescription: "现在扮演一名资深的图文设计师，协助我高质量完成任务，任务目标是将素材转化为引人注目的图文内容，包括编写精炼的文案和设计匹配的视觉图像或版式。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )//.map(t => { return {...t, value: `card_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "card_validation",
      // shortKey: "gc_validation",
      phaseTitle: "内容优化与格式调整",
      phaseDescription: "现在扮演一名资深的社交媒体编辑，协助我高质量完成任务，任务目标是检查图文内容的文案是否有错别字、图片风格是否统一，并根据不同平台的特性（如小红书、微博）提出格式调整建议。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "optimization" // "validation" -> "check"
      )//.map(t => { return {...t, value: `card_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装媒体文案工作流。
 * 流程：明确目标 -> 研究热点 -> 生成文案 -> 优化校对。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getCopywritingWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "copy_guidance",
      // shortKey: "cw_guidance",
      phaseTitle: "文案目标与平台适配",
      phaseDescription: "现在扮演一名资深的资深文案策划，协助我高质量完成任务，任务目标是引导我明确这篇文案的商业目标（如提升点击率、促进购买）、发布平台和目标读者的核心心理。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `copy_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "copy_research",
      // shortKey: "cw_research",
      phaseTitle: "热点追踪与关键词研究",
      phaseDescription: "现在扮演一名资深的SEO分析师，协助我高质量完成任务，任务目标是研究与主题相关的热门搜索关键词、用户痛点问题和高转化率文案的结构，为写作提供方向。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `copy_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "copy_generation",
      // shortKey: "cw_creation",
      phaseTitle: "多平台文案生成与适配",
      phaseDescription: "现在扮演一名资深的金牌文案写手，协助我高质量完成任务，任务目标是根据要求，撰写出多个版本的、具有吸引力标题和强说服力内容的文案初稿，并适配不同平台的语调。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )//.map(t => { return {...t, value: `copy_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "copy_validation",
      // shortKey: "cw_validation",
      phaseTitle: "文案优化与SEO检查",
      phaseDescription: "现在扮演一名资深的文案优化师，协助我高质量完成任务，任务目标是对初稿进行润色，检查其可读性、情感共鸣和行动号召（CTA）是否清晰有力，并进行SEO关键词优化。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "optimization" // "validation" -> "check"
      )//.map(t => { return {...t, value: `copy_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装小说创作工作流。
 * 流程：构建世界观 -> 收集素材 -> 创作章节 -> 优化文风。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getNovelCreationWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "novel_guidance",
      // shortKey: "nc_guidance",
      phaseTitle: "小说概念与世界观构建",
      phaseDescription: "现在扮演一名资深的世界观架构师，协助我高质量完成任务，任务目标是与我一同探讨，构建出小说的核心概念、基本设定（时代、魔法/科技体系）和主要人物的初步构想。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `novel_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "novel_research",
      // shortKey: "nc_research",
      phaseTitle: "背景研究与素材收集",
      phaseDescription: "现在扮演一名资深的历史/文化研究顾问，协助我高质量完成任务，任务目标是根据世界观设定，为我提供相关的历史背景、文化风俗、服饰建筑等细节素材，以增强故事的真实感。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `novel_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "novel_generation",
      // shortKey: "nc_creation",
      phaseTitle: "故事发展与章节创作",
      phaseDescription: "现在扮演一名资深的故事作家，协助我高质量完成任务，任务目标是基于设定和素材，创作出精彩的故事情节大纲、具体的章节内容，并塑造丰满的人物形象和对话。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "ideation" || task.shortName === "generation"
      )//.map(t => { return {...t, value: `novel_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "novel_validation",
      // shortKey: "nc_validation",
      phaseTitle: "情节连贯性与文风优化",
      phaseDescription: "现在扮演一名资深的文学编辑，协助我高质量完成任务，任务目标是审阅已创作的章节，检查情节是否存在逻辑漏洞、人物行为是否合理、文笔风格是否统一，并提出修改建议。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "feedback" // "validation" -> "check"
      )//.map(t => { return {...t, value: `novel_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装音乐工坊工作流。
 * 流程：定位风格 -> 获取灵感 -> 创作旋律 -> 编排优化。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getMusicWorkshopWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "music_guidance",
      // shortKey: "mw_guidance",
      phaseTitle: "音乐风格与情感定位",
      phaseDescription: "现在扮演一名资深的音乐制作人，协助我高质量完成任务，任务目标是与我沟通，明确这首歌曲想要传达的核心情感（如喜悦、悲伤、燃）、目标听众和音乐风格（如流行、摇滚、民谣）。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `music_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "music_research",
      // shortKey: "mw_research",
      phaseTitle: "音乐理论与灵感获取",
      phaseDescription: "现在扮演一名资深的音乐理论家，协助我高质量完成任务，任务目标是根据定下的风格，为我提供经典的曲式结构、和声进行和配器方案作为参考和灵感。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `music_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "music_generation",
      // shortKey: "mw_creation",
      phaseTitle: "旋律创作与歌词编写",
      phaseDescription: "现在扮演一名资深的作曲家/作词人，协助我高质量完成任务，任务目标是基于情感和理论，创作出动听的主旋律、富有诗意的歌词，并设计出歌曲的整体结构。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )//.map(t => { return {...t, value: `music_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "music_validation",
      // shortKey: "mw_validation",
      phaseTitle: "和声编排与混音优化",
      phaseDescription: "现在扮演一名资深的编曲师，协助我高质量完成任务，任务目标是评估当前的旋律和歌词，为其设计合适的和声、配器和节奏，并对整体的听感和表现力提出优化方案。",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "optimization" // "validation" -> "check"
      )//.map(t => { return {...t, value: `music_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}

/**
 * @description 组装电影编剧工作流。
 * 流程：确立概念 -> 题材研究 -> 剧本创作 -> 评估优化。
 * @param {string} href - 标识符
 * @returns {FlowStage[]}
 */
export function getScreenplayWorkflow(href: string): FlowStage[] {
  return [
    {
      ...guidance[0],
      phaseKey: "film_guidance",
      // shortKey: "sp_guidance",
      phaseTitle: "电影概念与核心冲突",
      phaseDescription: "现在扮演一名资深的制片人，协助我高质量完成任务，任务目标是与我一起头脑风暴，确立电影的核心创意（一句话故事）、主题思想以及主角面临的核心冲突。",
      phaseTasks: guidance[0].phaseTasks.filter(task => 
        task.shortName === "initiation" || task.shortName === "dialogue"
      )//.map(t => { return {...t, value: `film_guidance.${t.shortName}`}})
    },
    {
      ...researcher[0],
      phaseKey: "film_research",
      // shortKey: "sp_research",
      phaseTitle: "题材研究与背景设定",
      phaseDescription: "现在扮演一名资深的电影研究员，协助我高质量完成任务，任务目标是为我搜集与题材相关的背景资料、经典影片案例和人物原型素材，为剧本创作提供深度和依据。",
      phaseTasks: researcher[0].phaseTasks.filter(task => 
        task.shortName === "collection" || task.shortName === "analysis"
      )//.map(t => { return {...t, value: `film_research.${t.shortName}`}})
    },
    {
      ...producer[0],
      phaseKey: "film_generation",
      // shortKey: "sp_creation",
      phaseTitle: "剧本创作与分镜设计",
      phaseDescription: "现在扮演一名资深的职业编剧，协助我高质量完成任务，任务目标是按照标准格式，将故事构思发展成完整的分场大纲、人物小传，并撰写出具体的场景和对话内容。",
      phaseTasks: producer[0].phaseTasks.filter(task => 
        task.shortName === "generation" || task.shortName === "variation"
      )//.map(t => { return {...t, value: `film_generation.${t.shortName}`}})
    },
    {
      ...validator[0],
      phaseKey: "film_validation",
      // shortKey: "sp_validation",
      phaseTitle: "剧本评估与节奏优化",
      phaseTasks: validator[0].phaseTasks.filter(task => 
        task.shortName === "check" || task.shortName === "feedback" // "validation" -> "check"
      )//.map(t => { return {...t, value: `film_validation.${t.shortName}`}})
    }
  ].filter(Boolean) as FlowStage[];
}


export const getPhaseDescriptioin = (path?: string, phaseKey?:string): string => {
  if (!path || ! phaseKey) return '';

  if (path === phaseKey) {

    return '';
  }

  const {docs: stages, workflow} = getWorkflowData('#' + path);
  let phaseDescription = '';
  // 安全检查：确保输入是数组且不为空
  if (!Array.isArray(stages) || stages.length === 0) {
    console.log('!确保输入是数组且不为空');
    return phaseDescription;
  }
  stages.forEach((phase: FlowStage, index) => {
    // 安全检查：确保phase对象存在且包含必要属性
    if (!phase || typeof phase !== 'object') {
      console.log('!确保phase对象存在且包含必要属性');
      return phaseDescription;
    }
    if (phase.phaseKey === phaseKey) {
      phaseDescription = phase.phaseDescription || '';
    }
  });
  sslog('getPhaseDescriptioin:', {phaseDescription, path, phaseKey});
  return phaseDescription;
}

function formatValidatorLog(stages: FlowStage[], path:string): string {
  // 安全检查：确保输入是数组且不为空
  if (!Array.isArray(stages) || stages.length === 0) {
    console.log('!确保输入是数组且不为空');
    return '';
  }
  let formatContent =  '';

  let workflow =  '';
  let steps = '';
  stages.forEach((phase: FlowStage, index) => {
    // 安全检查：确保phase对象存在且包含必要属性
    if (!phase || typeof phase !== 'object') {
      console.log('!确保phase对象存在且包含必要属性');
      return '';
    }

    const phaseKey = phase.phaseKey || '未知阶段';
    const phaseTitle = phase.phaseTitle || '';
    const phaseDescription = phase.phaseDescription || '';
    workflow += `.${phaseKey}(`;

    // formatContent += `- ${phaseKey}阶段: ${phaseTitle}-${phaseDescription}\n`
    formatContent += `阶段${index+1}: ${phaseTitle}(${phaseKey})-${phaseDescription}\n`
    // 打印阶段信息
    // console.log(`- ${phaseKey}阶段: ${phaseTitle}-${phaseDescription}`);
    
    // 安全检查：确保phaseTasks存在且是数组
    if (!Array.isArray(phase.phaseTasks)) {
      console.log('!确保phaseTasks存在且是数组');
      return '';
    }
    
    // 打印任务信息
    phase.phaseTasks.forEach((task: FlowTask, i) => {
      // 安全检查：确保task对象存在且包含必要属性
      if (!task || typeof task !== 'object') {
        console.log('!确保task对象存在且包含必要属性');
        return '';
      }
      const taskName = task.shortName || '未知任务';
      const taskLabel = task.label || '';
      const taskDescription = task.description || '';
      steps += `${taskName},`;
      formatContent += ` - ${index+1}.${i+1} ${taskLabel}(${taskName})-${taskDescription}\n`
      // formatContent += ` - ${index+1}.${i+1} ${taskLabel}(${taskName})\n`
    });

    steps = steps.substring(0, steps.length-1);
    workflow += `${steps})`;
    steps = '';
  });

  /// sslog('formatContent:\n', {formatContent, workflow: `workflow(${path})` + workflow});

  return `workflow(${path})` + workflow;
}

// 工作流数据获取函数
const workflowCache = new Map<string, FlowStage[]>();
export const getWorkflowData = (path: string): {docs: FlowStage[], workflow: string} => {

  // 检查缓存
  // console.log('getWorkflowData:', path);
  if (workflowCache.has(path)) {
    console.log('getWorkflowData workflowCache:', workflowCache);

    return {docs:workflowCache.get(path)!, workflow: formatValidatorLog(workflowCache.get(path) || [], path)};
  }

  let result: FlowStage[] = guidance;
    console.log('getWorkflowData guidance:', result);

  switch (path) {
    case '#system': result = system; break;

    // 基础工作流
    // case '#guidance': result = guidance;
    case '#tutor': result = tutor; break;
    case '#researcher': result = researcher; break;
    case '#producer': result = producer; break;
    case '#validator': result = validator; break;
    case '#allbasic': result = result.concat(researcher, producer, validator);  break; //result.push(...researcher, ...producer, ...validator);  // push 不会生成新数组，直接操作原数组，避免了额外的内存开销。
    //[...guidance, ...researcher, ...producer, ...validator];  扩展运算符在底层优化了数组展开逻辑（如 V8 引擎的优化）。
    // //guidance.concat(researcher, producer, validator);
    // 特定场景工作流
    case '#strategy': result = getStrategyWorkflow(path);  break;
    case '#promotion': result = getPromotionWorkflow(path);  break;
    case '#product-design': result = getProductDesignWorkflow(path);  break;
    case '#software-dev': result = getSoftwareDevWorkflow(path);  break;
    case '#graphic-card': result = getGraphicCardWorkflow(path);  break;
    case '#copywriting': result = getCopywritingWorkflow(path);  break;
    // case '#novel-creation': result = getNovelCreationWorkflow(path);  break;
    case '#novel-creation': result = novel; break;
    case '#music-workshop': result = getMusicWorkshopWorkflow(path);  break;
    case '#screenplay': result = getScreenplayWorkflow(path);  break;
    
    default: ;
  }

  console.log('getWorkflowData result:', JSON.stringify(result));
  console.log('getWorkflowData formatValidatorLog:', formatValidatorLog(result, path));

  // 存入缓存
  workflowCache.set(path, result);
  return {docs: result, workflow: formatValidatorLog(result || [], path)};

  // return result;
};
